import React from 'react'

const OptionsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
        <path className='custom-icon' d="M3.54167 7.5835C2.7625 7.5835 2.125 8.221 2.125 9.00016C2.125 9.77933 2.7625 10.4168 3.54167 10.4168C4.32083 10.4168 4.95833 9.77933 4.95833 9.00016C4.95833 8.221 4.32083 7.5835 3.54167 7.5835Z" fill="#20272B"/>
        <path className='custom-icon' d="M13.4596 7.5835C12.6805 7.5835 12.043 8.221 12.043 9.00016C12.043 9.77933 12.6805 10.4168 13.4596 10.4168C14.2388 10.4168 14.8763 9.77933 14.8763 9.00016C14.8763 8.221 14.2388 7.5835 13.4596 7.5835Z" fill="#20272B"/>
        <path className='custom-icon' d="M8.4987 7.5835C7.71953 7.5835 7.08203 8.221 7.08203 9.00016C7.08203 9.77933 7.71953 10.4168 8.4987 10.4168C9.27786 10.4168 9.91536 9.77933 9.91536 9.00016C9.91536 8.221 9.27786 7.5835 8.4987 7.5835Z" fill="#20272B"/>
    </svg>
  )
}

export default OptionsIcon
